import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeSerialNoCreate,
  detail: routeSerialNoDetail,
  home: routeSerialNosHome,
  root: routeSerialNosRoot,
} = createDoctypeRoutes({
  createName: 'new-serial-no',
  createPath: 'new-serial-no',
  detailName: 'serial-no-detail',
  doctype: DOCTYPES.SERIAL_NO,
  homeName: 'serial-nos',
  path: 'serial-nos',
  views: {
    create: async () => await import('@/components/viewsExternal/serialNos/AddSerialNo.vue'),
    detail: async () => await import('@/components/viewsExternal/serialNos/ViewSerialNo.vue'),
    list: async () => await import('@/components/viewsExternal/itemsModule/ViewItems.vue'),
  },
})

export { routeSerialNoCreate, routeSerialNoDetail, routeSerialNosHome, routeSerialNosRoot }
